/* eslint-disable max-len */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App/App';
import './i18n';
import { appStore } from './redux-saga/store';
import theme from './theme/theme';
import * as serviceWorker from './serviceWorker';

const {
  fonts: { bold, semibold, regular },
} = theme;

const RegularFontFace = {
  fontFamily: 'regular',
  src: `
    url(${regular}) format('woff2')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const SemiBoldFontFace = {
  fontFamily: 'semibold',
  src: `
    url(${semibold}) format('woff2')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const BoldFontFace = {
  fontFamily: 'bold',
  src: `
    url(${bold}) format('woff2')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const materialTheme = createMuiTheme({
  typography: {
    fontSize: '16px',
    htmlFontSize: '18.25px',
    fontFamily: 'regular',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [RegularFontFace, SemiBoldFontFace, BoldFontFace],
      },
    },
  },
});

ReactDOM.render(
  <MuiThemeProvider theme={materialTheme}>
    <CssBaseline />
    <Provider store={appStore}>
      <App />
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
